import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getLookupsSpecieVariety = async () => {
	const { data } = await axios.get(`${API}/maintainers/business_center/specie_variety/lookups`);
	return data;
};

export const getSpecieVarieties = async (filters) => {
	const { data } = await axios.get(`${API}/maintainers/business_center/specie_variety/list`, { params: filters });
	return data;
};

export const getSpecieVariety = async (filters) => {
	const { data } = await axios.get(`${API}/maintainers/business_center/specie_variety/detail`, { params: filters });
	return data;
};

export const saveSpecieVariety = async (payload) => {
	const { data } = await axios.post(`${API}/maintainers/business_center/specie_variety/save`, payload);
	return data;
};

export const deleteSpecieVariety = async (payload) => {
	const { data } = await axios.post(`${API}/maintainers/business_center/specie_variety/delete`, payload);
	return data;
};

export const importExcelSpecieVariety = async (formData) => {
	const { data } = await axios.post(`${API}/maintainers/business_center/specie_variety/import_excel`, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return data;
};
